<template>
  <q-card>
    <q-card-section>
      <q-form @submit="onSubmit">
        <q-input
            v-model="question.Title"
            label="عنوان پرسش را اینجا وارد نمایید"
            filled
            clearable
            clear-icon="clear"
        >
        </q-input>
        <q-select
            class="q-mt-xs"
            v-model="question.AnswerType"
            filled
            label="نوع پاسخ"
            :options="questionTypes"
            option-label="Title"
            option-value="ID"
            clearable
        />
        <q-select
            v-if="question.AnswerType && (question.AnswerType.ID===3 ||question.AnswerType.ID===4)"
            class="q-mt-xs"
            v-model="question.Answers"
            filled
            label="پاسخ ها"
            clearable
            use-input
            use-chips
            multiple
            hide-dropdown-icon
            new-value-mode="add-unique"
        />
        <q-separator spaced/>
        <q-btn label="تایید" icon="check" color="primary" type="submit"/>
        <q-btn label="انصراف" icon="cancel" color="negative" flat/>
      </q-form>
    </q-card-section>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "QuestionsCU",
  props: {
    items: {
      type: []
    },
    questionListInfo: {
      type: Object
    }
  },
  data() {
    return {
      question: {
        ID: undefined,
        ParentID: this.questionListInfo.ID,
        Title: undefined,
        AnswerType: undefined,
        Answers: [],
        action: undefined
      },
      questionTypes: [
        {ID: 1, Title: 'تشریحی'},
        {ID: 2, Title: 'تشریحی تک خطی'},
        {ID: 3, Title: 'چند گزینه ای'},
        {ID: 4, Title: 'تک گزینه ای'},
        {ID: 5, Title: 'بلی/خیر'},
        {ID: 6, Title: 'مقدار عددی'},
        {ID: 7, Title: 'تاریخ'},
      ]
    }
  },
  methods: {
    ...mapActions({
      crudQuestion: 'Questions/crudQuestions'
    }),
    onSubmit() {
      this.addNewItem()
    },
    addNewItem() {
      if (this.question.ID === undefined) {
        this.question.action = 'insert'
        this.crudQuestion(this.question).then((res) => {
          this.items.push(res[0])
          this.question = {
            ID: undefined,
            ParentID: this.questionListInfo.ID,
            Title: undefined,
            AnswerType: undefined,
            AnswerTypeTitle: undefined,
            Answers: []
          }
        })
      } else {
        this.question.action = 'update'
        this.crudQuestion(this.question).then((res) => {
          const index = this.items.findIndex(item => {
            return (res[0].ID === item.ID)
          })
          this.items.splice(index, 1, res[0])
          this.question = {
            ID: undefined,
            ParentID: this.questionListInfo.ID,
            Title: undefined,
            AnswerType: undefined,
            AnswerTypeTitle: undefined,
            Answers: []
          }
        })

      }
    },
    getSelectedItem(item) {
      this.question.ID = item.ID
      this.question.Title = item.Title
      this.question.AnswerType = JSON.parse(item.AnswerType)
      this.question.Answers = JSON.parse(item.Answers)
    }
  },
  created() {

  },
  mounted() {
    this.$root.$on('question-selected', this.getSelectedItem)
  }
}
</script>

<style scoped>

</style>